import firstDaysImg from '../assets/first-days.jpg';
import discoverIssuesImg from '../assets/discover-issues.jpg';
import reduceAssumptionsImg from '../assets/reduce-assumptions.jpg';
import learnAboutYourUsersImg from '../assets/learn-about-your-users.jpg';
import findPatternsInHeatmapsImg from '../assets/find-patterns-in-heatmaps.jpg';
import heatmapMissingDataImg from '../assets/heatmap-missing-data.jpg';
import howToSetupHeatmapImg from '../assets/how-to-setup-heatmap.jpg';
import howToExportHeatmapsImg from '../assets/how-to-export-heatmaps.jpg';
import howToUseContinuousHeatmapsImg from '../assets/how-to-use-continuous-heatmaps.jpg';
import typesOfHeatmapsImg from '../assets/types-of-heatmaps.jpg';
import gettingStartedWithFiltersImg from '../assets/getting-started-with-filters.jpg';
import eventsForRecordingsImg from '../assets/events-for-recordings.jpg';
import findInsightsInRecordingsImg from '../assets/find-insights-in-recordings.jpg';
import howToExportRecordingsImg from '../assets/how-to-export-recordings.jpg';
import filterRecordingsByUserFeedbackImg from '../assets/filter-recordings-by-user-feedback.jpg';
import captureSessionsUnder30SecondsImg from '../assets/capture-sessions-under-30-seconds.jpg';
import hotjarWithSlackImg from '../assets/hotjar-with-slack.jpg';
import learnAboutYourUsersWithUserAttributesImg from '../assets/learn-about-your-users-with-user-attributes.jpg';
import useHotjarToFindBugsOrUxIssuesImg from '../assets/use-hotjar-to-find-bugs-or-ux-issues.jpg';
import findDropOffsFromAUserFlowImg from '../assets/find-drop-offs-from-a-user-flow.jpg';

export interface IArticle {
  link: string;
  image: string;
  articleKey: string;
}

export type Tips = {
  [key: string]: IArticle;
};

export const HOTJAR_TIPS: Tips = {
  '55f00615a9804415b93cce3d1210e0f0': {
    link: 'https://learning.hotjar.com/courses/your-first-30-days-with-hotjar',
    image: firstDaysImg,
    articleKey: 'first-days',
  },
  d8c0d841903444728fee235a1ceb6692: {
    link: 'https://learning.hotjar.com/courses/how-to-discover-issues-and-prioritize-fixes',
    image: discoverIssuesImg,
    articleKey: 'discover-issues',
  },
  c1f5c5cea6ef4d588ededc7833539675: {
    link: 'https://learning.hotjar.com/courses/how-to-reduce-assumptions-using-hotjar',
    image: reduceAssumptionsImg,
    articleKey: 'reduce-assumptions',
  },
  a5ed935e035e487ea51e20207dc794e0: {
    link: 'https://learning.hotjar.com/courses/events-for-recordings',
    image: learnAboutYourUsersImg,
    articleKey: 'learn-about-your-users',
  },
  '4b2891df37a7428ebf9f38d6251f2846': {
    link: 'https://learning.hotjar.com/courses/how-to-find-patterns-in-heatmaps',
    image: findPatternsInHeatmapsImg,
    articleKey: 'find-patterns-in-heatmaps',
  },
  '0d14797d083642c886a1fc2ffdf9eb17': {
    link: 'https://youtu.be/DZQysW7AGQU?t=505',
    image: heatmapMissingDataImg,
    articleKey: 'heatmap-missing-data',
  },
  '98730134fa7742dabe83f0339473bc08': {
    link: 'https://youtu.be/M4jlIIHiJMY?t=426',
    image: howToSetupHeatmapImg,
    articleKey: 'how-to-setup-heatmap',
  },
  b3ef7750b6084c6b83fc3b4a23f09fc6: {
    link: 'https://www.youtube.com/watch?v=S9Nr0gFBKPQ',
    image: howToExportHeatmapsImg,
    articleKey: 'how-to-export-heatmaps',
  },
  '4d5f10aca56c40c5964cf8ddd5301823': {
    link: 'https://www.youtube.com/watch?v=uLltSKEWX40',
    image: howToUseContinuousHeatmapsImg,
    articleKey: 'how-to-use-continuous-heatmaps',
  },
  '8f84d2cdb5724de083527e03760ec1d8': {
    link: 'https://help.hotjar.com/hc/en-us/articles/115011867048',
    image: typesOfHeatmapsImg,
    articleKey: 'types-of-heatmaps',
  },
  b646cb9845ab41fea5d28ecbdfae44f7: {
    link: 'https://learning.hotjar.com/courses/getting-started-with-filters-and-segments',
    image: gettingStartedWithFiltersImg,
    articleKey: 'getting-started-with-filters',
  },
  '7ce65db2f99d47d2aa38f40c8af9ec14': {
    link: 'https://learning.hotjar.com/courses/events-for-recordings',
    image: eventsForRecordingsImg,
    articleKey: 'events-for-recordings',
  },
  bba976d82cab44f6bcf3c3f794b4b82d: {
    link: 'https://learning.hotjar.com/courses/how-to-find-insights-in-recordings',
    image: findInsightsInRecordingsImg,
    articleKey: 'find-insights-in-recordings',
  },
  '8c658ca7ea6f44149982354ac905c4d7': {
    link: 'https://www.youtube.com/watch?v=_rUEt8F5Drg',
    image: howToExportRecordingsImg,
    articleKey: 'how-to-export-recordings',
  },
  '579ebc153737416e9d4b9a7990a7df71': {
    link: 'https://www.youtube.com/watch?v=Y-3KI__Ekmc',
    image: filterRecordingsByUserFeedbackImg,
    articleKey: 'filter-recordings-by-user-feedback',
  },
  '01a33828cfeb4080a0957cef6e57acb2': {
    link: 'https://www.youtube.com/watch?v=5QA1Ix9l9l8',
    image: captureSessionsUnder30SecondsImg,
    articleKey: 'capture-sessions-under-30-seconds',
  },
  fbc43435b85b40c78492dbb5853f58c1: {
    link: 'https://learning.hotjar.com/courses/how-to-use-hotjar-with-slack',
    image: hotjarWithSlackImg,
    articleKey: 'hotjar-with-slack',
  },
  '37e97441e149457194a24b53596fc9a4': {
    link: 'https://learning.hotjar.com/courses/how-to-learn-about-your-users-with-user-attributes',
    image: learnAboutYourUsersWithUserAttributesImg,
    articleKey: 'learn-about-your-users-with-user-attributes',
  },
  '6dbb0139eb4d45789710690c81a3efe4': {
    link: 'https://help.hotjar.com/hc/en-us/articles/7052701186839-How-Can-I-Use-Hotjar-to-Find-Bugs-or-UX-Issues-',
    image: useHotjarToFindBugsOrUxIssuesImg,
    articleKey: 'use-hotjar-to-find-bugs-or-ux-issues',
  },
  '3d90a81d51294b478d47300e8f54787f': {
    link: 'https://help.hotjar.com/hc/en-us/articles/7000446410135-How-Can-I-Find-Drop-Offs-from-a-User-Flow-',
    image: findDropOffsFromAUserFlowImg,
    articleKey: 'find-drop-offs-from-a-user-flow',
  },
};
